"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var image_scenario_node_component_1 = __importDefault(require("../image-scenario-node/image-scenario-node.component"));

var image_explanation_scenario_node_component_1 = __importDefault(require("../image-explanation-scenario-node/image-explanation-scenario-node.component"));

var greeting_scenario_node_container_1 = __importDefault(require("../greeting-scenario-node/greeting-scenario-node.container"));

var text_scenario_node_container_1 = __importDefault(require("../text-scenario-node/text-scenario-node.container"));

var selectNodeView = function selectNodeView(node, scale) {
  switch (node.type) {
    case scenario_state_1.ScenarioNodeType.Greeting:
      return react_1.default.createElement(greeting_scenario_node_container_1.default, {
        scale: scale
      });

    case scenario_state_1.ScenarioNodeType.Text:
      return react_1.default.createElement(text_scenario_node_container_1.default, {
        node: node,
        scale: scale
      });

    case scenario_state_1.ScenarioNodeType.Image:
      return react_1.default.createElement(image_scenario_node_component_1.default, {
        node: node,
        scale: scale
      });

    case scenario_state_1.ScenarioNodeType.ImageExplanation:
      return react_1.default.createElement(image_explanation_scenario_node_component_1.default, {
        node: node,
        scale: scale
      });

    default:
      return react_1.default.createElement("p", null, "\u8A72\u5F53\u3059\u308B\u5439\u304D\u51FA\u3057\u304C\u5B58\u5728\u3057\u307E\u305B\u3093");
    //TODO show error message
  }
};

var ScenarioNodeView = function ScenarioNodeView(_ref) {
  var node = _ref.node,
      scale = _ref.scale;
  return selectNodeView(node, scale);
};

exports.default = ScenarioNodeView;